import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';

const GlobalStyles = createGlobalStyle`
  ${reset};
  a {
    text-decoration:none;
    color:inherit;
  }
  *:not(.ck-content *) {
    box-sizing: border-box;
    /* font-size: 62.5%; */
    /* antd : 100% -> 14px */
    /* font-size: 12px; */
  }
  html {
    font-size: 62.5%;
  }
  body, div, span, h1, h2, h3, h4, h5, h6, p, 
  a, dl, dt, dd, ol, ul, li, form, label, input, select {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 1.2rem;
  }
  table {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 0.5rem;
  }
  th { white-space: nowrap; }
  body {
    line-height: 1;
  }
  ol, ul {
    /* list-style: none; */
  }  
  [class*=ant-] {
    font-size: 1.2rem;
  }
    
  /* CKEditor 내부 요소들에는 전역 스타일을 적용하지 않도록 예외 처리 */
  .ck-content *:not(path) {
    all: revert; /* 기본 스타일을 유지하면서 전역 스타일 영향 제거 */
  }
`;

export default GlobalStyles;
